import React from 'react';
import { useFetch } from '../hook/useFecth';
import { Icon } from '@iconify/react/dist/iconify.js';

const DashboardLayer = () => {
    const { data, isLoading } = useFetch('/dashboard');
    const { data: aniversariantes, isLoading: isLoadingAniversariantes } = useFetch('/dashboard/aniversariantes');

    const formatarDataNascimento = (dataNascimento) => {
        if (!dataNascimento) return '';
        const data = new Date(dataNascimento);
        return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    };

    const obterDiaAniversario = (dataNascimento) => {
        if (!dataNascimento) return '';
        const data = new Date(dataNascimento);
        return data.getDate();
    };

    return (
        <div className="container-fluid">
            <div className="row g-3 mb-4">
                {/* Card de Clientes Ativos */}
                <div className="col-md-6 col-lg-6">
                    <div className="card shadow-sm border-0 radius-8 h-100">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="text-sm text-secondary-light mb-2 fw-normal">
                                        Clientes Ativos
                                    </h6>
                                    <h2 className="text-2xl fw-bold mb-0 text-primary">
                                        {isLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </span>
                                        ) : (
                                            data?.qtdClientesAtivo || 0
                                        )}
                                    </h2>
                                </div>
                                <div className="w-64-px h-64-px radius-16 bg-primary-50 d-flex justify-content-center align-items-center flex-shrink-0">
                                    <Icon
                                        icon="mdi:account-group"
                                        width="32"
                                        height="32"
                                        className="text-primary"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card de Pedidos Finalizados */}
                <div className="col-md-6 col-lg-6">
                    <div className="card shadow-sm border-0 radius-8 h-100">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="text-sm text-secondary-light mb-2 fw-normal">
                                        Pedidos Finalizados
                                    </h6>
                                    <h2 className="text-2xl fw-bold mb-0 text-success">
                                        {isLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </span>
                                        ) : (
                                            data?.qtdPedidosFinalizados || 0
                                        )}
                                    </h2>
                                </div>
                                <div className="w-64-px h-64-px radius-16 bg-success-50 d-flex justify-content-center align-items-center flex-shrink-0">
                                    <Icon
                                        icon="mdi:check-circle"
                                        width="32"
                                        height="32"
                                        className="text-success"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lista de Aniversariantes */}
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm border-0 radius-8">
                        <div className="card-header border-bottom bg-base py-16 px-24">
                            <div className="d-flex align-items-center gap-2">
                                <Icon
                                    icon="mdi:cake-variant"
                                    width="24"
                                    height="24"
                                    className="text-warning"
                                />
                                <h6 className="mb-0 fw-semibold">Aniversariantes do Mês</h6>
                            </div>
                        </div>
                        <div className="card-body p-24">
                            {isLoadingAniversariantes ? (
                                <div className="text-center py-4">
                                    <span className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </span>
                                </div>
                            ) : aniversariantes && aniversariantes.length > 0 ? (
                                <div className="row g-3">
                                    {aniversariantes.map((aniversariante) => (
                                        <div key={aniversariante.id} className="col-md-6 col-lg-4">
                                            <div className="card border-0 radius-8 bg-gradient-start-1 h-100">
                                                <div className="card-body p-3">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="w-48-px h-48-px radius-12 bg-warning-50 d-flex justify-content-center align-items-center flex-shrink-0">
                                                            <Icon
                                                                icon="mdi:cake"
                                                                width="24"
                                                                height="24"
                                                                className="text-warning"
                                                            />
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <h6 className="text-md mb-1 fw-semibold">
                                                                {aniversariante.nome}
                                                            </h6>
                                                            <div className="d-flex flex-column gap-1">
                                                                {aniversariante.email && (
                                                                    <span className="d-flex align-items-center gap-1 text-sm text-secondary-light">
                                                                        <Icon icon="mdi:email" width="14" height="14" />
                                                                        {aniversariante.email}
                                                                    </span>
                                                                )}

                                                                {aniversariante.telefone && (
                                                                    <span className="d-flex align-items-center gap-1 text-sm text-secondary-light">
                                                                        <Icon icon="mdi:phone" width="14" height="14" />
                                                                        {aniversariante.telefone}
                                                                    </span>
                                                                )}

                                                                <span className="d-flex align-items-center gap-1 text-sm fw-medium text-warning">
                                                                    <Icon icon="mdi:calendar" width="14" height="14" />
                                                                    Dia {obterDiaAniversario(aniversariante.dataNascimento)} - {formatarDataNascimento(aniversariante.dataNascimento)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <Icon
                                        icon="mdi:cake-off"
                                        width="48"
                                        height="48"
                                        className="text-secondary-light mb-2"
                                    />
                                    <p className="text-secondary-light mb-0">Nenhum aniversariante este mês</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayer;
